import { SUBSCRIPTION_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import FormattedPropertyV2 from 'customer-data-properties/formatted/FormattedPropertyV2';
import PropertyInputV2 from 'customer-data-properties/input/PropertyInputV2';
import { View } from 'foundations-components/components/View';
import emptyFunction from 'react-utils/emptyFunction';
import { jsx as _jsx } from "react/jsx-runtime";
const alwaysUndefined = emptyFunction.thatReturns(undefined);
export function MaybeEditProperty({
  isReadonly,
  objectId,
  property,
  inputProps = {},
  hasWriteScope,
  onChange,
  getDraftValue
}) {
  if (!hasWriteScope || isReadonly) {
    return /*#__PURE__*/_jsx(View, {
      as: "span",
      "data-test-id": "subscription-readonly-property-value:hs_status",
      children: /*#__PURE__*/_jsx(FormattedPropertyV2, {
        objectTypeId: SUBSCRIPTION_TYPE_ID,
        objectId: objectId,
        property: property.definition,
        value: property.value,
        getDraftValue: alwaysUndefined,
        getSavedValue: alwaysUndefined
      })
    });
  }
  return /*#__PURE__*/_jsx(View, {
    as: "span",
    "data-test-id": "subscription-property-value:hs_status",
    children: /*#__PURE__*/_jsx(PropertyInputV2, {
      objectTypeId: SUBSCRIPTION_TYPE_ID,
      objectId: objectId,
      property: property.definition,
      use: "compact",
      inputMode: "edit",
      value: property.value,
      onChange: onChange,
      getDraftValue: getDraftValue,
      getSavedValue: alwaysUndefined,
      inputProps: inputProps
    })
  });
}